import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { Observable, pipe, switchMap, tap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { ArrangementsService } from '@thiememeulenhoff/ng-api-gateway';
import { Arrangement } from '@thiememeulenhoff/types';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type ArrangementsState = {
  arrangements: Array<Arrangement>;
};

const initialState: ArrangementsState = {
  arrangements: [],
};

export const ArrangementsStore = signalStore(
  { providedIn: 'root' },
  withState(initialState),
  withRequestStatus(),
  withMethods((store, arrangements = inject(ArrangementsService)) => {
    const fetchWith = (
      fetch: (methodSlug: string) => Observable<Array<Arrangement>>,
    ) =>
      rxMethod<string>(
        pipe(
          tap(() => patchState(store, { requestStatus: 'loading' })),
          switchMap((methodSlug) =>
            fetch(methodSlug).pipe(
              tapResponse({
                next: (arrangements) =>
                  patchState(store, {
                    arrangements,
                    requestStatus: 'success',
                  }),
                error: (error: unknown) =>
                  patchState(store, {
                    requestStatus: toRequestError(
                      error,
                      'Failed to fetch arrangements',
                    ),
                  }),
              }),
            ),
          ),
        ),
      );

    return {
      fetchPredefinedArrangements: fetchWith((methodSlug) =>
        arrangements.fetchArrangements('predefined', methodSlug),
      ),
      fetchUserDefinedArrangements: fetchWith((methodSlug) =>
        arrangements.fetchArrangements('userdefined', methodSlug),
      ),
    };
  }),
);
